import { isIOS } from 'react-device-detect';
import * as constants from '../constants';

export const CommonScrollUtils = {
  scrollYiOS: 0,
  isLocked: false,
  isRestoringScroll: false, // flag to suppress scroll callbacks
  isRestoringScroll_count: 0,
  /**
   * Smooth scroll to a position and run callbacks
   */
  scrollToWithCallback: (targetY) => {
    //console.log('Global - scrollToWithCallback - scroll restored to', CommonScrollUtils.scrollYiOS, window.scrollY);
    const startY = window.scrollY || window.pageYOffset;
    const distance = targetY - startY;
    const duration = 100; // milliseconds
    let startTime = null;

    CommonScrollUtils.isRestoringScroll = true; // suppress callbacks
    CommonScrollUtils.isRestoringScroll_count = 0;

    //console.log('Global - scroll restored to', CommonScrollUtils.scrollYiOS, window.scrollY);

    const step = (timestamp) => {
      //console.log('Global - scroll restored to', CommonScrollUtils.scrollYiOS, window.scrollY);
      if (!startTime) startTime = timestamp;
      const progress = Math.min((timestamp - startTime) / duration, 1);
      //console.log('Global - scroll restored to-startY + distance * progress', startY + distance * progress);
      window.scrollTo(0, startY + distance * progress);
      //console.log('Global - scroll restored to', CommonScrollUtils.scrollYiOS, window.scrollY, CommonScrollUtils.isRestoringScroll_count);
      CommonScrollUtils.isRestoringScroll_count = CommonScrollUtils.isRestoringScroll_count + 1;
      if (progress < 1) {
        //console.log('Global - scroll restored to', CommonScrollUtils.scrollYiOS, window.scrollY);
        requestAnimationFrame(step);
      } else {
        //CommonScrollUtils.isRestoringScroll = false; // re-enable callbacks
        //console.log('Global - scroll restored to', CommonScrollUtils.scrollYiOS, window.scrollY);
      }
    };

    requestAnimationFrame(step);

    //console.log('Global - scrollToWithCallback--22-- - scroll restored to', CommonScrollUtils.scrollYiOS, window.scrollY);
  },

  /**
   * Lock scroll (iOS popup open)
   */
  lockScroll: () => {
    //console.log("Global - lockScroll", CommonScrollUtils.scrollYiOS, window.scrollY);

    if (!isIOS || constants?.IOS_ON_OFF_TOUCH_MOVE !== 1) return;
    if (CommonScrollUtils.isLocked) return;

    //console.log("Global - lockScroll", CommonScrollUtils.scrollYiOS, window.scrollY);

    CommonScrollUtils.isLocked = true;

    CommonScrollUtils.scrollYiOS = window.scrollY;

    document.body.style.position = 'fixed';
    document.body.style.top = `-${CommonScrollUtils.scrollYiOS}px`;
    document.body.style.left = '0';
    document.body.style.right = '0';
    document.body.style.width = '100%';

    document.body.classList.add("modal-open");

    //CommonScrollUtils.enableTouchBlock();

  },

  /**
   * Unlock scroll (iOS popup close)
   */
  unlockScroll: () => {
    //console.log("Global - unlockScroll", CommonScrollUtils.scrollYiOS, window.scrollY);

    if (!isIOS || constants?.IOS_ON_OFF_TOUCH_MOVE !== 1) return;
    if (!CommonScrollUtils.isLocked) return;

    //console.log("Global - unlockScroll", CommonScrollUtils.scrollYiOS, window.scrollY);

    CommonScrollUtils.isLocked = false;

    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.left = '';
    document.body.style.right = '';
    document.body.style.width = '';

    document.body.classList.remove("modal-open");

    //CommonScrollUtils.disableTouchBlock();

    // CommonScrollUtils.scrollToWithCallback(
    //   CommonScrollUtils.scrollYiOS
    // );

    // window.scrollTo(0, CommonScrollUtils.scrollYiOS);
    // Restore scroll without page "reload feel"
    window.scrollTo({
      top: CommonScrollUtils.scrollYiOS,
      behavior: 'instant' // no smooth scroll → prevents visible jump
    });    

  },

  /**
   * Prevent touch scrolling
   */
  //preventTouchScroll: (e) => e.preventDefault(),

  // preventTouchScroll: (e) => {
  //   console.log("Global - preventTouchScroll");
  //   if (!isIOS || constants?.IOS_ON_OFF_TOUCH_MOVE !== 1) return;
  //   console.log("Global - preventTouchScroll-----111111------------11111111-");
  //   e.preventDefault();
  //   console.log("Global - preventTouchScroll-----222222------------22222222-");

  // }, 
  
  preventTouchScroll: (e) => {
    if (!isIOS || constants?.IOS_ON_OFF_TOUCH_MOVE !== 1) return;
    e.preventDefault();
  },   

  enableTouchBlock: () => {
    //console.log("Global - enableTouchBlock");
    if (!isIOS || constants?.IOS_ON_OFF_TOUCH_MOVE !== 1) return;
    document.body.addEventListener('touchmove', CommonScrollUtils.preventTouchScroll, {
      passive: false,
    });
    //console.log("Global - enableTouchBlock-----333333------------333333-");
  },

  disableTouchBlock: () => {
    //console.log("Global - disableTouchBlock");
    if (!isIOS || constants?.IOS_ON_OFF_TOUCH_MOVE !== 1) return;
    document.body.removeEventListener('touchmove', CommonScrollUtils.preventTouchScroll);
    //console.log("Global - disableTouchBlock-----44444------------4444444-");
  },

  /**
   * Helper: call this in your scroll event listener
   */
  handleScrollEvent_isRestoringScroll: () => {
    //console.log("Global - handleScrollEvent_isRestoringScroll");
    if (isIOS && constants?.IOS_ON_OFF_TOUCH_MOVE === 1 && CommonScrollUtils.isRestoringScroll) return true;
    else return false;        
  },

  handleScrollEvent_setRestoringScroll: () => {
    //console.log("Global - handleScrollEvent_setRestoringScroll");
    CommonScrollUtils.isRestoringScroll = false; // re-enable callbacks       
  },  

  /**
   * Helper: call this in your scroll event listener
   */
  handleScrollEvent: (scrollCallback) => {
    //console.log('Global - handleScrollEvent', CommonScrollUtils.scrollYiOS, window.scrollY, CommonScrollUtils.isRestoringScroll);
    //console.log("Global - handleScrollEvent-----66666------------666666666-isIOS,IOS_ON_OFF_TOUCH_MOVE:", isIOS, constants?.IOS_ON_OFF_TOUCH_MOVE);
    if (isIOS && constants?.IOS_ON_OFF_TOUCH_MOVE === 1 && CommonScrollUtils.isRestoringScroll) return; // ignore while restoring
    scrollCallback && scrollCallback();
    //console.log("Global - handleScrollEvent-----55555------------555555555-");
  },

};
